import React from "react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styleListData from "./ListDisputeData.module.css";
import MainContent from "../../../layouts/maincontent/MainContent";
import Pagination, {
  PaginationTax,
} from "../../../shared/pagination/Pagination";
import SelectElement from "../../../shared/form/SelectElement";
import InputElement from "../../../shared/form/InputElement";
import { get_tax_disputes } from "../../../adapters/apis/taxDispute/list";
import {
  getTaxTypesWithAll,
  getRequeststatuses,
} from "../../../adapters/apis/lookups/lookups";
import { get } from "../../../adapters/xhr/api";

import Moment from "moment";
import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import { DatePickerFormatedWithLimit } from "../../../shared/form/DatePickerFormated";
import disputePrint from "../../../assets/img/print.png";
import disputeInfo from "../../../assets/img/Icon feather-file-text.png";
import { useLocation } from "react-router-dom";

function ListDisputeData() {
  const [taxType, settaxType] = useState([]);
  const [tax_declarations, setTaxDeclarations] = useState([]);
  const [declarationsLength, setDeclarationsLength] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [startFrom, setStartFrom] = useState(1);
  const [active, setActive] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [flashMessage, setFlashMessage] = useState(false);
  const [requestCount, setRequestCount] = useState(true);

  // const limit = 1;

  const [limit, setLimit] = useState(100);

  const initialFilters = {
    request_number: "",
    tax_type: "",
    from_date: "",
    to_date: "",
    status: "",
    per_page: limit,
  };

  const [filters, setFilters] = useState({
    request_number: "",
    tax_type: "",
    from_date: "",
    to_date: "",
    status: "",
    per_page: limit,
  });

  const location = useLocation();
  const navigate = useNavigate();
  const initialState = location.state || {};
  const [cancelMessage, setCancelMessage] = useState(
    location.state?.message || null,
  );
  const [successMessage, setSuccessMessage] = useState(
    location.state?.successMessage || null,
  );

  const [countAlertMessage, setCountAlertMessage] = useState(
    location.state?.countAlertMessage || null,
  );
  const [countAlert, setCountAlert] = useState(
    location.state?.countAlert || null,
  );

  useEffect(() => {
    checkVerfication();
  }, []);

  const checkVerfication = async () => {
    try {
      const response = await get("api/user/verifications", {}, true);
      const isFullyVerified = response?.data?.fully_verified;
      if (!isFullyVerified) {
        navigate("/DisabledHome");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // Clear the history state to prevent reappearance on refresh
    // if (location.state && (cancelMessage || successMessage || countAlert)) {
    //   navigate(location.pathname, { replace: true, state: null });
    // }
    if (Object.keys(initialState).length > 0) {
      navigate(location.pathname, { replace: true, state: null });
    }
  }, []);

  useEffect(() => {
    if (cancelMessage || successMessage || countAlert) {
      const timer = setTimeout(() => {
        if (cancelMessage) {
          setCancelMessage(null); // Clear the message after 10 seconds
        } else if (successMessage) {
          setSuccessMessage(null); // Clear the message after 10 seconds
        } else if (countAlert) {
          setCountAlert(null); // Clear the
          setCountAlertMessage(null);
        }
      }, 5000);

      return () => clearTimeout(timer); // Cleanup on unmount
    }
  }, [cancelMessage, successMessage, countAlert]);
  const [filtersErrors, setFiltersErrors] = useState({
    request_number: "",
    tax_type: "",
    from_date: "",
    to_date: "",
    status: "",
  });

  const [success, setSuccess] = useState("");

  const [error, setError] = useState(null);

  const changeDataFormat = (filters) => {
    const data = {
      request_number: filters?.request_number,
      tax_type: filters?.tax_type,
      from_date: filters?.from_date
        ? Moment(filters?.from_date).format("yyyy-MM-DD")
        : "",
      to_date: filters?.to_date
        ? Moment(filters?.to_date).format("yyyy-MM-DD")
        : "",
      status: filters?.status,
      per_page: limit,
    };
    return data;
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit); // Update
    setCurrentPage(1); // Reset to first
    // callback(1); // Fetch data for page 1
  };

  useEffect(() => {
    setIsLoading(true);

    if (localStorage.getItem("success")) {
      setSuccess(localStorage.getItem("success"));
      localStorage.removeItem("success");
    }

    // get tax_declarations for logged user
    get_tax_disputes({}, currentPage, changeDataFormat(filters))
      .then((res) => {
        setDeclarationsLength(res?.data?.data?.total);
        setTaxDeclarations(res?.data?.data?.data);
        setCurrentPage(res?.data?.data?.current_page);
        setStartFrom(res?.data?.data?.from);
        setError(res?.data?.data?.message);
        setRequestCount(res?.data?.data?.requests_count);

        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });

    // set Declaration Real Estate Type
    getTaxTypesWithAll().then((res) => {
      settaxType(res?.data?.data);
    });

    // set Declaration Real Estate Type
    getRequeststatuses().then((res) => {
      setStatusList(res?.data?.data);
    });
  }, [active, limit]);

  function callback(active) {
    setIsLoading(true);
    setCurrentPage(active);
    get_tax_disputes({}, active, changeDataFormat(filters)).then((res) => {
      setDeclarationsLength(res?.data?.data?.total);
      setTaxDeclarations(res?.data?.data?.data);
      setStartFrom(res?.data?.data?.from);
      setRequestCount(res?.data?.data?.requests_count);

      setError(res?.data?.data?.message);

      setIsLoading(false);
    });
  }

  const handleFromDateChange = (parentCompenent, compenent, key, value) => {
    // If both from_date and to_date have values, clear to_date
    if (filters.from_date && filters.to_date) {
      setFilters((prev) => ({
        ...prev,
        to_date: "",
      }));
    }

    // Update the from_date field
    setFilters((prev) => ({
      ...prev,
      [key]: value,
      to_date: "",
    }));
  };

  const data = tax_declarations?.map((element, index) => {
    return (
      <tr key={element.id}>
        <td data-label="رقم الطلب">{element?.request_number}</td>
        <td data-label="نوع الضريبة">
          {element?.tax_type ? element?.tax_type : ""}
        </td>
        <td data-label="حالة الطلب">
          {element?.request_status ? element?.request_status : ""}
        </td>
        <td data-label="تاريخ تقديم الطلب">
          {element?.submitted_request_date}
        </td>
        <td data-label="تفاصيل">
          <Link
            to={"/tax-dispute-request/details/" + element?.id}
            className={styleListData["btn-file"]}
            id="dispute_info_icon"
          >
            <img src={disputeInfo} className="img-fluid" />
          </Link>
        </td>
        <td data-label="طباعة حالة الطلب">
          {
            <Link
              target="_blank"
              id="pdf-Receipt"
              to={"/tax-dispute/request-print-pdf/" + element?.request_number}
              className={styleListData["btn-pdf"]}
            >
              {/*<button type="button" className={ `btn-file-print` } onClick={onButtonClick}>*/}
              <span className="text d-lg-none d-block">طباعة</span>
              <span className="icon d-lg-block d-none" target="_blank">
                <img src={disputePrint} className="img-fluid" />
              </span>
            </Link>
          }
        </td>
      </tr>
    );
  });
  const taxType_options = taxType?.map((element) => {
    return (
      <option value={element.id} key={element.id}>
        {element?.name}
      </option>
    );
  });

  const status_options = statusList?.map((element) => {
    return (
      <option value={element.id} key={element.id}>
        {element?.name}
      </option>
    );
  });

  function search() {
    setFlashMessage(false); // Clear the flash message
    setIsLoading(true);
    setCurrentPage(1);
    const formattedFilters = changeDataFormat(filters);
    // Call API with filters
    get_tax_disputes({}, 1, formattedFilters).then((res) => {
      setDeclarationsLength(res?.data?.data?.total);
      setTaxDeclarations(res?.data?.data?.data);
      setCurrentPage(res?.data?.data?.current_page);
      setStartFrom(res?.data?.data?.from);
      setError(res?.data?.data?.message);
      setIsLoading(false);
    });
  }

  function clear() {
    setFlashMessage(false); // Clear the flash message
    setFilters(initialFilters);
    setCurrentPage(1);
    setIsLoading(true);
    get_tax_disputes({}, 1, initialFilters).then((res) => {
      setDeclarationsLength(res?.data?.data?.total);
      setTaxDeclarations(res?.data?.data?.data);
      setCurrentPage(res?.data?.data?.current_page);
      setStartFrom(res?.data?.data?.from);
      setError(res?.data?.data?.message);

      setIsLoading(false);
    });
  }
  function changeFilters(parentCompenent, compenent, key, value) {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  const checkCount = (e) => {
    if (!requestCount) {
      e.preventDefault();
      setFlashMessage(true); // Prevent navigation
    }
  };
  return (
    <MainContent>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <section className={`${styleListData.listData}`}>
            <div className="container pt-4">
              <div className={styleListData.box}>
                <div className={`${styleListData["box-header"]}`}>
                  <h3 className={`${styleListData["box-title"]} mb-0`}>
                    إنهاء المنازعات الضريبية
                  </h3>
                  <div className={styleListData["btns-header"]}>
                    <Link
                      to="/tax-dispute/add"
                      className={styleListData["btns-header-order"]}
                      id="dispute_add_button"
                      onClick={checkCount}
                    >
                      تقديم طلب
                    </Link>
                  </div>
                </div>
                <div className={`${styleListData["box-body"]}  mt-3`}>
                  {(flashMessage || countAlert) && (
                    <div className="alert alert-danger">
                      <h3 className="fs-5">
                        لقد تجاوزت الحد المسموح لتقديم الطلبات، يرجى الانتظار
                        حتى يتم اتخاذ القرار في أحد طلباتك لكي تتمكن من تقديم
                        طلب جديد
                      </h3>
                    </div>
                  )}
                  {cancelMessage && (
                    <div
                      className="alert alert-warning"
                      id="cancel-message-dispute-request"
                    >
                      {cancelMessage}
                    </div>
                  )}
                  {successMessage && (
                    <div className="alert alert-success">{successMessage}</div>
                  )}
                  {success !== "" && (
                    <div className="alert alert-primary">{success}</div>
                  )}
                  <div className={`${styleListData["box-body-content"]}`}>
                    <div className="row align-items-center px-md-4">
                      <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                        <InputElement
                          name="request_number"
                          mb4="mb-4"
                          labelHtmlFor="request_number"
                          labelClassName={`${styleListData["form-label"]} form-label`}
                          labelText="رقم الطلب"
                          inputType="text"
                          inputClassName="form-control"
                          inputID="request_number"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={filters.request_number}
                          onChange={changeFilters}
                          pText={filtersErrors.request_number}
                          maxLength="255"
                          placeholder="أدخل رقم الطلب" // Add this line
                        />
                      </div>
                      <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                        <SelectElement
                          mb4="mb-4"
                          labelHtmlFor="tax_type"
                          labelClassName={`  form-label ${styleListData["form-label"]}`}
                          labelText="نوع الضريبة"
                          selectClassName={`${styleListData["form-select"]} form-select`}
                          selectID="tax_type"
                          name="tax_type"
                          options={taxType_options}
                          default="نوع الضريبة"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={filters.tax_type}
                          onChange={changeFilters}
                          pText={filtersErrors.tax_type}
                          style={{ color: "#32A8ED" }}
                          placeholderText="نوع الضريبة"
                        />
                      </div>
                      <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                        <SelectElement
                          mb4="mb-4"
                          labelHtmlFor="status"
                          labelClassName={`  form-label  ${styleListData["form-label"]}`}
                          labelText="حالة الطلب"
                          selectClassName={`${styleListData["form-select"]} form-select`}
                          selectID="status"
                          name="status"
                          options={status_options}
                          default="حالة الطلب"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={filters.status}
                          onChange={changeFilters}
                          pText={filtersErrors.status}
                          placeholderText="حالة الطلب"
                        />
                      </div>
                      <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                        <DatePickerFormatedWithLimit
                          name="from_date"
                          name_datepicker="from_date"
                          mb4="mb-4"
                          labelHtmlFor="from_date"
                          labelClassName={`  ${styleListData["form-label"]} form-label`}
                          labelText="من تاريخ تقديم الطلب"
                          inputType="datePicker"
                          max={Moment().subtract(500, "years")}
                          min={Moment().subtract(18, "years")}
                          inputClassName="form-control"
                          inputID="to_dfrom_dateate"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          pText={filtersErrors.from_date}
                          value={filters.from_date}
                          placeholderText="من تاريخ تقديم الطلب" // Add Arabic placeholder
                          onChange={handleFromDateChange} // Use the new handler
                        />
                      </div>
                      <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                        <DatePickerFormatedWithLimit
                          name="to_date"
                          name_datepicker="to_date"
                          mb4="mb-4"
                          labelHtmlFor="to_date"
                          labelClassName={`  ${styleListData["form-label"]} form-label`}
                          labelText="إلى تاريخ تقديم الطلب"
                          inputType="datePicker"
                          // max={Moment().subtract(500, "years")}
                          // min={Moment().subtract(18, "years")}
                          inputClassName={`${styleListData["form-control"]} form-control`}
                          inputID="to_date"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          pText={filtersErrors.to_date}
                          value={filters.to_date}
                          valueDate={filters.to_date}
                          onChange={changeFilters}
                          minDate={filters.from_date} // Pass the from_date value as minDate
                          placeholderText="إلى تاريخ تقديم الطلب" // Add Arabic placeholder
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-end p-3">
                      <button
                        className={styleListData["btns-search"]}
                        onClick={search}
                        id="dispute_search_button"
                      >
                        بحث
                      </button>
                      <button
                        className={styleListData["btns-clear"]}
                        onClick={clear}
                        id="dispute_clear_button"
                      >
                        إعادة
                      </button>
                    </div>
                  </div>
                  <div
                    className={`${styleListData["table-responsive"]} table-responsive`}
                  >
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">رقم الطلب</th>
                          <th scope="col">نوع الضريبة</th>
                          <th scope="col">حالة الطلب</th>
                          <th scope="col">تاريخ تقديم الطلب</th>
                          <th scope="col">تفاصيل</th>
                          <th scope="col">طباعة حالة الطلب</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.length > 0 ? (
                          data
                        ) : (
                          <tr>
                            <td colSpan={6} className="h5 text-center">
                              {error}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {/* {declarationsLength > limit ? ( */}
                  <PaginationTax
                    limit={limit}
                    count={declarationsLength}
                    active={currentPage}
                    callback={callback}
                    handleLimitChange={handleLimitChange}
                  />
                  {/* ) : (
                    ""
                  )} */}
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </MainContent>
  );
}

export default ListDisputeData;
